export default __webpack_public_path__ + "static/media/1489.51770ce5.png";